export function get(key): string | null {
	if (!window.localStorage) {
		return null;
	}

	return window.localStorage.getItem(key);
}

export function getArray(key): Array<string> {
	const arr = get(key);

	return arr ? decodeURIComponent(arr).split(',') : [];
}

export function getFromCookie(key): string | null {
	if (!window.navigator.cookieEnabled) {
		return null;
	}

	const cookieArr = document.cookie.match('(?:^|;\\s*)' + key + '=([^;]*)');

	return cookieArr?.[1] ?? null;
}

export default {
	get,
	getArray,
	getFromCookie
};
